import { CognitoUserPool, CognitoUser, CognitoUserAttribute, AuthenticationDetails } from 'amazon-cognito-identity-js';
import AWS from 'aws-sdk';
import Cookies from 'js-cookie';

const poolData = {
  UserPoolId: process.env.USERPOOL_ID, 
  ClientId: process.env.CLIENT_ID
};
const poolId= process.env.POOL_ID

const userPool = new CognitoUserPool(poolData);

export const signUp = (username, email, password) => {
  return new Promise((resolve, reject) => {
    const emailAttribute = new CognitoUserAttribute({
      Name: 'email',
      Value: email,
    });

    const attributeList = [emailAttribute];

    userPool.signUp(username, password, attributeList, null, (err, result) => {
      if (err) {
        reject(err); 
        return;
      }
      resolve(result); 
      alert('Code sent to your email!');
    });
  });
};


export const confirmSignup = (username, password, verificationCode) => {
  const user = new CognitoUser({ Username: username, Pool: userPool });

  return new Promise((resolve, reject) => {
    user.confirmRegistration(verificationCode, true, (err, result) => {
      if (err) {
        // console.error('Error confirming signup:', err);
        reject(err);
      } else {
        // console.log('User confirmed successfully:', result);
        resolve(result);
        alert('Account created successfully!')
      }
    });
  });
};



export const resendConfirmCode = (username) =>{
  const user = new CognitoUser({ Username: username, Pool: userPool });
  user.resendConfirmationCode(function (err, result) {
    if (err) {
      alert(err.message || JSON.stringify(err));
      return;
    }
    // console.log('call result: ' + result);
    alert('Code sent to your email!');
  });
}


export const logIn = (username, password, setUser, setIdToken, setS3, logout) => {
  const user = new CognitoUser({ Username: username, Pool: userPool });
  const authDetails = new AuthenticationDetails({ Username: username, Password: password });
  return new Promise((resolve, reject) => {
    user.authenticateUser(authDetails, {
      onSuccess: (session) => {
        const idToken = session.getIdToken().getJwtToken();
        Cookies.set('idToken', idToken, {
          secure: window.location.protocol === 'https:', 
          sameSite: 'Strict', 
          path: '/', 
        });
        setIdToken(idToken)
        setUser(user)
        // console.log(Cookies)

        // console.log('Authentication successful:', { idToken });

        // Configure AWS credentials
        AWS.config.region = 'us-west-2';
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: poolId, 
          Logins: {
            [`cognito-idp.us-west-2.amazonaws.com/${poolData.UserPoolId}`]: idToken,
          },
        });

        AWS.config.credentials.clearCachedId();
        AWS.config.credentials.refresh((err) => {
          if (err) {
            // console.error('Failed to refresh AWS credentials:', err);
            reject(err);
          } else {
            // console.log('AWS credentials successfully refreshed:', AWS.config.credentials);

            const s3Instance = new AWS.S3();
            setS3(s3Instance); 
            resolve(session); 
          }
        });

        const tokenExpiration = session.getIdToken().getExpiration();
        const currentTime = Math.floor(Date.now() / 1000);
        // console.log(tokenExpiration)
        const date = new Date(tokenExpiration * 1000); 
        // console.log(date.toISOString());
        // console.log(currentTime)
        const timeUntilLogout = (tokenExpiration - currentTime) * 1000; 
        // console.log(timeUntilLogout)
        if (timeUntilLogout > 0) {
          setTimeout(() => {
            logout();
            // console.log('signout')
          }, timeUntilLogout);
        } else {
          logout();
          // console.log('signout')
        }
      },
      onFailure: (err) => {
        console.error('Authentication failed:', err);
        reject(err);
      },
    });
  });
};



export const resetPassword = (username, verificationCode, newPassword) => {
  const user = new CognitoUser({ Username: username, Pool: userPool });

  return new Promise((resolve, reject) => {
    user.confirmPassword(verificationCode, newPassword, {
      onSuccess() {
        // console.log('Password confirmed!');
        alert('Password confirmed!');
        resolve(true)
      },
      onFailure(err) {
        // console.log('Password not confirmed!');
        reject(err)
      },
    });
  })  
} 

export const forgetPassword = (username) => {
  const user = new CognitoUser({ Username: username, Pool: userPool });

  return new Promise((resolve, reject) => {
    user.forgotPassword({
      onSuccess: (data) => {
        // console.log('Password reset initiated successfully. Code delivery data:', data.CodeDeliveryDetails.Destination);
        alert('Code sent to: ' + data.CodeDeliveryDetails.Destination);
        resolve(true)
      },
      onFailure: (err) => {
        // console.error('Error initiating password reset:', err.message || JSON.stringify(err));
        reject(err)
      },
    });
  })
};


export const signOut = () => {
  const user = userPool.getCurrentUser();
  if (user) user.signOut();
};

export const getCurrentUser = () => {
  return userPool.getCurrentUser();
};

export const refreshToken = (setIdToken, setS3, id_token) => {
  const cognitoUser = userPool.getCurrentUser();

  if (!cognitoUser) {
    console.error('No current user found.');
    return;
  }

  cognitoUser.getSession((err, session) => {
    // console.log(session)
    if (err) {
      console.error('Error retrieving session:', err);
      return;
    }

    const refreshToken = session.getRefreshToken();
    cognitoUser.refreshSession(refreshToken, (err, newSession) => {
      if (err) {
        console.error('Error refreshing session:', err);
        return;
      }

      const idToken = newSession.getIdToken().getJwtToken();
      // console.log(id_token==idToken)
      // console.log(idToken)
      setIdToken(idToken)
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: poolId,
        Logins: {
          [`cognito-idp.us-west-2.amazonaws.com/${poolData.UserPoolId}`]: idToken,
        },
      });

      AWS.config.credentials.refresh((err) => {
        if (err) {
          console.error('Error refreshing AWS credentials:', err);
        } else {
          // console.log('AWS credentials successfully updated.');
          const s3Instance = new AWS.S3();
          setS3(s3Instance);
        }
      });

      return;
    });
  });
};

